<div class="px-3 pt-2 pb-5">
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="px-4 pb-4">
  <div class="row no-gutters">
    <div class="col col-auto">
      <img class="logo-image" src="assets/logo/ingo-logo.svg" alt="">
    </div>
    <div class="col">
      <div class="font-weight-bold">INGO</div>
      <div>
        <button class="btn btn-link p-0" (click)="openApp()">{{ 'mobileAppModal.viewBtn' | translate }}</button>
      </div>
    </div>
  </div>
</div>
<div class="px-4 pb-4" ngbAutofocus>
  {{ 'mobileAppModal.content' | translate }}
</div>
<div class="text-right px-4 pb-4">
  <button class="btn btn-link text-uppercase font-weight-bold" (click)="dismiss()">{{ 'mobileAppModal.skipBtn' | translate }}</button>
  <button class="btn btn-link text-uppercase font-weight-bold" (click)="openApp()">{{ 'mobileAppModal.openBtn' | translate }}</button>
</div>
<div class="p-4">
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox" id="stop-showing" [(ngModel)]="stopShowing">
    <label class="form-check-label" for="stop-showing">
      Don’t show this message again
    </label>
  </div>
</div>